.page {
  padding: 1.5rem 2rem 3rem;
  max-width: 46rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.home {
  color: var(--muted);
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
}

.intro {
  color: var(--muted);
  margin: 0 0 0.5rem;
}

.form {
  display: flex;
  gap: 0.5rem;
  align-items: flex-end;
}

.inputWrap {
  flex: 1;
}

.examples {
  margin-top: 0.5rem;
}

.exampleButtons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.label {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--muted);
  margin: 0 0 0.4rem;
}

.asked {
  margin: 0;
}

.error {
  color: var(--stop);
}

.notice {
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  background: var(--paper-2);
  padding: 1rem 1.25rem;
}

.notice p {
  margin: 0 0 0.4rem;
}
